import React, { useState,useEffect } from 'react';
import { useHistory } from "react-router-dom"; 
import styled from 'styled-components';  
import MatchingChatRoom from 'components/containers/matching/room/MatchingChatRoom';
import TitleHeader from 'components/presenters/header/TitleHeader';
import CenterModal from 'components/presenters/modal/CenterModal';
import server from 'server/serverController2';

export default function MatchingRoomLayout({match}) {
  const history = useHistory(); 
  const [roomInfo, setRoomInfo] = useState(null); 
  const [profileInfo, setProfileInfo] = useState(null);

  //Center Modal State
  const [initCenterModal, setInitCenterModal] = useState(false);
  const [centerModalVisible, setCenterModalVisible] = useState(false);
  const [centerModalDataList, setCenterModalDataList] = useState({});
  const [onModalComplete, setOnModalComplete] = useState(null);
  const [onModalCancel, setOnModalCancel] = useState(null);

  const loadRoomInfo = () => {
    if(match?.params?.room_no)
    {
      let roomNo = match['params']['room_no'];
      server.getRequestData(`matching/rooms/${roomNo}`,(res)=>{
        if(res.success === 0)
        {
          return;
        }
        const roomInfo = res.data;
        setRoomInfo(roomInfo);
      })
    }
  }
  const loadProfileInfo = () => {
    server.getRequestData('matching/profile',(res)=>{
      if(res.success === 0)
      {
        let errData = res['error']['res_data'];
        if(errData['detail_code'] === 'MATCHING_PROFILE_DOES_NOT_EXIST')
        {
          setCenterModalVisible(true);
          setCenterModalDataList({description:`매칭 프로필 정보가 존재하지 않습니다.`});
          setOnModalComplete(()=>()=>{
            history.replace('/matching/survey');
            setInitCenterModal(true);
          })
        }
        else
        {
          setCenterModalVisible(true);
          setCenterModalDataList({description:`예기치 못한 오류가 발생하였습니다.`});
          setOnModalComplete(()=>()=>{
            history.push('/');
            setInitCenterModal(true);
          })
        }
        return ;
      }
      let profileInfo = res['data'];
      setProfileInfo(profileInfo);
    });
  }
  //Init Center Modal State
  useEffect(()=>{
    if(initCenterModal === true)
    {
      setCenterModalVisible(false);
      setCenterModalDataList({})
      setOnModalComplete(null);
      setOnModalCancel(null);
      setInitCenterModal(false);
    }
  }, [initCenterModal])

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(()=>{
    const init = ()=>{
      loadProfileInfo();
      loadRoomInfo();
    }
    init();
  },[]);

  const handleExitRoom = async (e) =>{
    if(match?.params?.room_no)
    {
      let roomNo = match['params']['room_no'];
      await server.deleteRequestData(`matching/rooms/${roomNo}/members`, {});
      history.replace('/matching');
    }
  }

  let titleDom = (roomInfo) ? (<>{roomInfo['title']} <CapacityNum>{roomInfo['current_capacity']}</CapacityNum></>):(<></>);
  return (
    <MainLayout>
      <HeaderSection>
        <TitleHeader onBackBtn={null} title={titleDom} showExitBtn={true} onExit={handleExitRoom}/>
      </HeaderSection>
      <BodySection>
        <MatchingChatRoom roomInfo={roomInfo} profileInfo={profileInfo} onJoinRoom={()=>{loadRoomInfo()}}/>
      </BodySection>
      <CenterModal modalVisible={centerModalVisible} setModalVisible={setCenterModalVisible} dataList={centerModalDataList} onCancel={onModalCancel} onComplete={onModalComplete}/>
    </MainLayout>
  );
}
const MainLayout = styled.div`
  display: flex;
  flex-flow: column;
  height: 100vh;
  overflow: hidden;
`;

const HeaderSection = styled.div`
  height: calc(100vw*(51/375));
  min-height: calc(100vw*(51/375));
  flex: 0 1 auto;
`;

const BodySection = styled.div`
  flex: 1 1 auto;
  height: 100%;
  background-color: #f7f7f7;
    overflow: hidden;
`;
const CapacityNum = styled.span`
  color: #7f7f7f;
  font-weight: bold;
`;